<template>
  <v-reports
    v-model="page"
    safe-report
    v-bind:headers="headers"
    v-bind:update="update"
    v-bind:data="histories"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
  >
    <template #header>
      <v-tabs fixed-tabs v-model="safe_model" height="100" icons-and-text>
        <v-tab>
          {{ uzs_value.toLocaleString() }} {{ $t(`uzs_value`) }}
          <v-icon x-large color="#607D8B">mdi-cash</v-icon>
        </v-tab>
        <v-tab>
          {{ usd_value.toLocaleString() }} {{ $t(`usd_value`) }}
          <v-icon x-large color="#5265fa">mdi-cash-usd</v-icon>
        </v-tab>
        <v-tab>
          {{ transfer_value.toLocaleString() }} {{ $t(`transfer_value`) }}
          <v-icon x-large color="red">mdi-bank</v-icon>
        </v-tab>
      </v-tabs>
    </template>
  </v-reports>
</template>

<script>
export default {
  data: () => ({
    data: [],
    page: 1,
    numPages: 1,
    data_loading: false,
    headers: [],
    safe_model: 0,
    uzs_value: 0,
    usd_value: 0,
    transfer_value: 0,
    histories: [],
    tab_values: ["uzs", "usd", "transfer"]
  }),
  computed: {},
  watch: {
    safe_model() {
      if (this.page != 1) {
        this.page = 1;
        return;
      }
      this.update();
    },
    page() {
      this.update();
    }
  },
  methods: {
    async update() {
      let result = this.$communicator.then(
        this,
        await this.$communicator("safe_resport", {
          params: {
            page: this.page,
            type: this.tab_values[this.safe_model]
          }
        })
      );
      if (!result) {
        result = {
          uzs_value: 0,
          usd_value: 0,
          transfer_value: 0,
          histories: []
        };
      }
      const { uzs_value, usd_value, transfer_value, histories } = result;

      this.uzs_value = uzs_value;
      this.usd_value = usd_value;
      this.transfer_value = transfer_value;
      this.histories = histories;
    },
    changePagination(page) {
      this.page = page;
    }
  },
  mounted() {
    this.headers = [
      {
        text: this.$t("type"),
        value: "history_type",
        available: true
      },
      {
        text: this.$t("by_user"),
        value: "by_user_name",
        available: true
      },
      {
        text: this.$t("value"),
        value: "value",
        available: true
      },
      {
        text: this.$t("date"),
        value: "date",
        available: true
      }
    ];
  }
};
</script>
